<template>
  <div>
    <h1><a href="https://www.desmos.com/calculator/7eboanfzne" class="text-decoration-none">
      Visualize this in Desmos
    </a></h1>

    <h1>Motivation</h1>
    <p> One way of SR inflation is using LNs that release at different timings. </p>
    <p>This is due to a flaw in a code</p>

    <a
      href="https://github.com/ppy/osu/blob/6944151486e677bfd11f2390163aca9161defbbf/osu.Game.Rulesets.Mania/Difficulty/Skills/Strain.cs"
      class="text-decoration-none fw-bold"
    >
      Strain.cs
    </a>
    <pre>
if (
  Precision.DefinitelyBigger(holdEndTimes[i], maniaCurrent.StartTime, 1) &&
  Precision.DefinitelyBigger(endTime, holdEndTimes[i], 1)
)
  holdAddition = 1.0;
    </pre>
    <p>In simpler terms: </p>
    <pre>
if (Current LN Tail > Previous LN Tail > Current LN Head)
then (bonus = 1.0)
    </pre>

    <h2>Current LN, Previous LN</h2>

    <p>
      The script loops through notes and calculating strain for each,
      in this case we're only looking at LNs.
    </p>

    <p>
      When looping, history of the previous LN is stored for <span class="fw-bold">each column</span>,
      thus the current LN can access the previous.
    </p>

    <p>
      The algorithm uses this history to compare if <code>bonus</code> should be awarded.
    </p>

    <h2>Cases</h2>
    <pre>
if (Current LN Tail > Previous LN Tail > Current LN Head)
then (bonus = 1.0)
    </pre>
    <p>
      This <code>if</code> statement is <code>true</code> for the following case
    </p>
    <pre>
                 Head           Tail
                  v              v
Current LN        [==============]
Previous LN ===========]
                       ^
                      Tail
    </pre>

    <p>
      However <code>false</code> for the following cases
    </p>
    <pre>
Current LN        [==============]
Previous LN =====================]
Previous LN ========================]
Previous LN ======]
    </pre>

    <p>
      Though equal, <code>Precision.DefinitelyBigger(..., ..., 1)</code> implies that
      the difference must be at least <span class="fw-bold">1 millisecond</span>
    </p>
    <p>
      Lastly these will never happen
    </p>

    <pre>
Current LN  [==============]
Previous LN    [===========]
Previous LN    [=============]
Previous LN    [========]
    </pre>
    <p>
      This is because the loop iterates through time, thus the
      <span class="fw-bold">Previous LN</span> must happen before the
      <span class="fw-bold">Current LN</span>.
    </p>
    <h3>Exploitation</h3>
    <p>
      Notice that <code>Precision.DefinitelyBigger(..., ..., 1)</code> is exploitable,
      mappers can separate LN releases by <span class="fw-bold">2 milliseconds</span>
      to trigger the <code>bonus</code>.
    </p>

    <h2>Hotfix</h2>
    <p>
      The hotfix addresses this issue by making <code>bonus</code>
      a continuous variable instead of a trigger.
    </p>

    <h3>Previous Algorithm</h3>
    <ul>
      <li><code>bonus = 1</code> if the gap is &gt; 1 ms.</li>
      <li><code>bonus = 0</code> if the gap is &lt = 1 ms.</li>
    </ul>
    <pre>
1.0 +     +-----------------
    |     |
0.5 +     |
    |     |
0.0 +-----+--------------------> Release Difference / ms
       1  2
    </pre>

    <h3>New Algorithm</h3>
    <ul>
      <li><code>bonus = 1</code> if the gap is &gt; 40 ms.</li>
      <li><code>bonus = 0.5</code> if the gap is = 24 ms.</li>
      <li><code>bonus = 0</code> if the gap is &lt; 8 ms.</li>
    </ul>
    <pre>
1.0 + - - - - - -+-----------
    |           /
0.5 + - - - - -/   Sigmoid Curve
    |         /|
0.0 +--------+-+---------------> Release Difference / ms
               24
    </pre>

  </div>
</template>


<script>
export default {
  name: "Blog004",
};

</script>

<style scoped></style>
